export default {
  ErrorCode: {
    SEND_OTP_ERROR: 'Gửi OTP lỗi',
    INVALID_TRADING_TOKEN: 'Token không hợp lệ',
    INVALID_OTP: 'OTP không hợp lệ',
    TIMEOUT: 'Quá thời gian xử lý',
    SYSTEM_ERROR: 'Lỗi hệ thống',
    DB_ACCESS_ERROR: 'Lỗi hệ thống',
    EOD_ERROR: 'Lỗi xử lý thông tin cuối ngày',
    RESOURCE_NOT_FOUND: 'Không tìm thấy thông tin tìm kiếm',
    NPUT_MISSING: 'Vui lòng nhập đủ thông tin',
    ACCOUNT_MISSIN: 'Không có tài khoản tương thích',
    TICKER_MISSING: 'Không có cổ phiếu tương thích',
    ORDER_TYPE_INVALID: 'Loại hình lệnh không hợp lệ',
    INPUT_FORMAT_INVALID: 'Định dạng dữ liệu không hợp lệ ',
    INPUT_INVALID: 'Dữ liệu nhập không hợp lệ',
    STOCK_PRICE_UNDEFINED: 'Không tìm thấy giá cổ phiếu',
    MARKET_SESSION_UNDEFINED: 'Không tìm thấy thông tin phiên giao dịch',
    ORDER_STATUS_REJECTED:
      'Không thể thực hiện yêu cầu dựa trên trạng thái lệnh hiện tại',
    CAN_NOT_REPLACE_PLO_ORDER: 'Không thể thay lệnh PLO',
    CAN_NOT_CANCEL_ATO_ORDER: 'Không thể huỷ lệnh ATO',
    CAN_NOT_CANCEL_MARKET_ORDER: 'Không thể huỷ lệnh',
    CAN_NOT_CANCEL_THAT_ORDER_ON_THIS_SESSION:
      'Không thể huỷ lệnh đã chọn trong phiên hiện tại',
    CAN_NOT_PLACE_ORDER_WITH_QUANTITY_GREATER_THAN_CURRENT_ROOM:
      'Không thể đặt lệnh với Khối lượng lớn hơn room còn lại của hệ thống',
    REMOTE_ACCESS_ERROR: 'Lỗi hệ thống',
    CAN_NOT_PLACE_PLO_ORDER_WITHOUT_MATCHED:
      'Không thể đặt lệnh PLO khi không có lệnh đối ứng khớp',
    CAN_NOT_CANCEL_PENDINGNEW_ORDER_IN_OPEN_SESSION:
      'Không thể huỷ lệnh ở trạng thái “Chờ gửi” trong phiên liên tục',
    INVALID_SECURITY_TYPE: 'Loại chứng khoán không hợp lệ',
    CAN_NOT_PLACE_ORDER_ON_HALTED_TICKER:
      'Không thể đặt lệnh trên mã đã ngừng giao dịch',
    CAN_NOT_PLACE_ORDER_ON_UNLISTED_TICKER:
      'Không thể đặt lệnh trên mã đã huỷ niêm yết',
    CAN_NOT_PLACE_ORDER_ON_SUSPENDED_TICKER:
      'Không thể đặt lệnh trên mã đã bị ngừng giao dịch',
    CAN_NOT_PLACE_ODD_LOT_ORDER_ON_SPECIAL_TICKER: 'Không thể đặt lệnh lô lẻ',
    CAN_NOT_PLACE_ORDER_WITH_THIS_TICKER_TYPE:
      'Không thể đặt lệnh với loại chứng khoán này',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_INTERMISSION_SESSION:
      'Không thể đặt loại lệnh này trong phiên nghỉ trưa',
    CANNOT_PLACE_OPPOSITE_ORDER_IN_THIS_SESSION:
      'Không thể đặt lệnh đối ứng trong phiên này',
    CANNOT_PLACE_OPPOSITE_ORDER:
      'Không thể đặt lệnh ngược chiều trên tài khoản',
    CANNOT_PLACE_CROSS_ORDER_ON_THAT_SESSION:
      'Không để đặt lệnh thoả thuận trong phiên này',
    CANNOT_PLACE_ADV_ORDER_ON_THIS_SESSION:
      'Không thể đặt lệnh quảng cáo trong phiên này',
    CANNOT_PLACE_CROSS_ORDER_ON_SPECIAL_TICKER:
      'Không thể đặt lệnh thoả thuận với mã này',
    CANNOT_PLACE_ADV_ORDER_ON_SPECIAL_TICKER:
      'Không thể đặt lệnh quảng cáo trên một số mã đặc biệt',
    CANNOT_PLACE_ADV_ORDER_ON_HALT_TICKER:
      'Không thể đặt lệnh quảng cáo trên mã đã ngừng giao dịch',
    CANNOT_PLACE_ADV_ORDER_ON_SUSPENDED_TICKER:
      'Không thể đặt lệnh quảng cáo trên mã đã bị cấm giao dịch',
    CANNOT_PLACE_ADV_ORDER_ON_UNLISTED_TICKER:
      'Không thể đặt lệnh quảng cáo trên mã không được niêm yết',
    CANNOT_CANCEL_CROSS_ORDER_ON_THAT_SESSION_AND_STATUS:
      'Không thể đặt lệnh thoả thuận trong phiên này',
    CANNOT_CONFIRM_OR_REJECT_CROSS_ORDER_ON_THAT_ORDER_STATUS:
      'Không thể đồng ý hoặc huỷ lệnh thoả thuận với trạng thái lệnh hiện tại',
    CANNOT_CONFIRM_OR_REJECT_CROSS_ORDER_ON_THIS_SESSION:
      'Không thể đồng ý hoặc huỷ lệnh thoả thuận với phiên này',
    REJECTED_BY_BUY_SIDE: 'Bị từ chối bởi bên mua',
    MISSING_BUY_CUSTODY: 'Vui lòng kiểm tra số lưu ký bên mua',
    MISSING_BUY_ACCOUNT: 'Vui lòng kiểm tra số tiểu khoản bên mua',
    MISSING_BUY_FIRM_ID: 'Vui lòng kiểm tra ID bên mua',
    MISSING_BUY_TRADER_ID: 'Vui lòng kiểm tra ID người đặt bên mua',
    TICKER_IS_NOT_IN_MARGIN_BASKET: 'Mã chứng khoán không thuộc rổ cho vay',
    MISSING_ADV_CONTACT: 'Thiếu thông tin đơn vị quảng cáo',
    MISSING_CONTRA_FIRM_ID: 'Thiếu thông tin công ty đối ứng',
    MISSING_CONTRA_TRADER_ID: 'Thiếu thông tin người giao dịch bên đối ứng',
    CANNOT_CANCEL_ADV_ORDER_WITH_THIS_STATUS:
      'Không thể huỷ lệnh quảng cáo với trạng thái hiện tại',
    CANNOT_CANCEL_ADV_ORDER_FROM_OTHER_FIRM:
      'Không thể huỷ lệnh quảng cáo từ công ty khác',
    INVALID_ADV_ORDER_ID: 'Số hiệu lệnh quảng cáo không hợp lệ',
    QUANTITY_NOT_MATCH_WITH_ADV_ORDER:
      'Khối lượng không khớp với khối lượng lệnh quảng cáo',
    TICKER_NOT_MATCH_WITH_ADV_ORDER:
      'Mã không khớp với khối lượng lệnh quảng cáo',
    CANNOT_CANCEL_ADV_ORDER_ON_THIS_SESSION:
      'Không thể huỷ lệnh quảng cáo trong phiên này',
    CANNOT_PLACE_MANY_CROSS_ORDER_ON_A_ADV_ORDER:
      'Cannot place many cross orders on a adv order',
    CANNOT_PLACE_CROSS_ORDER_ON_THIS_ADV_ORDER_STATUS:
      'Không thể đặt lệnh thoả thuận với trạng thái lệnh quảng cáo hiện tại',
    INVALID_BUY_FIRM_ID: 'Số hiệu bên mua không hợp lệ',
    CANNOT_PLACE_ONE_FIRM_CROSS_ORDER_ON_ADV_ORDER_FROM_OTHER_SIDE:
      'Không thể đặt lệnh thoả thuận 1 thành viên trên lệnh quảng cáo từ thành viên còn lại',
    CANNOT_PLACE_ONE_FIRM_CROSS_ORDER_ON_ADV_ORDER_FROM_OUR_SIDE:
      'Không thể đặt lệnh thoả thuận khác thành viên trên lệnh quảng cáo chiều mua của công ty',
    CANNOT_PLACE_CROSS_ORDER_ON_SELL_ADV_ORDER_FROM_OTHER_SIDE:
      'Không thể đặt lệnh thoả thuận trên lệnh quảng cáo chiều bán từ thành viên khác',
    CANNOT_PLACE_CROSS_ORDER_ON_UNKNOWN_ADV_ORDER:
      'Không thể đặt lệnh thoả thuận trên lệnh quảng cáo chưa xác định',
    INTERNAL_COMPARE_ERROR: 'Lỗi so sánh dữ liêu giữ các hệ thống',
    EXTERNAL_COMPARE_ERROR: 'Lỗi so sánh dữ liêu giữ các hệ thống',
    INVALID_INTERNAL_COMPARE_STATUS: 'Lỗi so sánh dữ liêu giữ các hệ thống',
    INVALID_EXTERNAL_COMPARE_STATUS: 'Vượt quá pool cho vay',
    PP0_EXCEED: 'Vượt sức mua',
    INVALID_VALIDATION_REPORT: 'Số lưu ký không hợp lệ.',
    REQ_TIMEOUT: 'Hành động không hợp lệ',
    INVALID_INPUT: 'Thông tin nhập không hợp lệ',
    REMOTE_SERVER_ERROR: 'Lỗi hệ thống',
    THIRD_PARTY_ERROR: 'Lỗi hệ thống',
    RESOURCE_NOT_FOUND: 'Lỗi hệ thống',
    FSS_EXCEPTION: 'Lỗi hệ thống',
    INVALID_ORDER_QUANTITY: 'Khối lượng đặt không hợp lệ',
    INVALID_ORDER_PRICE: 'Giá đặt không hợp lệ',
    INVALID_OTP: 'OTP không hợp lệ',
    INVALID_TRADING_TOKEN: 'Token không hợp lệ',
    METHOD_NOT_ALLOWED: 'Lỗi hệ thống',
    MISSING_PATH_VARIABLE: 'Lỗi hệ thống',
    CONFLICT_REQUEST_ID: 'Lỗi hệ thống',
    STOCK_NOT_ENOUGH: 'Không đủ khối lượng cổ phiếu',
    INVALID_PRICE: 'Không đủ khối lượng cổ phiếu',
    INVALID_ORDER_TYPE: 'Loại lệnh không hợp lệ',
    PURCHASING_POWER_NOT_ENOUGH: '',
    INVALID_ORDER_ID: 'ID lệnh không hợp lệ',
    INVALID_ORDER_STATE: 'Trạng thái lệnh không hợp lệ',
    OUT_OF_MARGIN_BASKET: 'Cổ phiếu không nằm trong rổ cho vay',
    VSD_INACTIVE: 'Lỗi hệ thống',
    INVALID_TRADING_SESSION: 'Phiên giao dịch không hợp lệ',
    BATCH_IN_PROGRESS: 'Lỗi hệ thống',
    INVALID_SUBACCOUNT_STATUS: 'Tiểu khoản chưa được kích hoạt',
    PENDING_REVERSE_ORDER: 'Không thể đặt lệnh vì lệnh đối ứng',
    TRADING_SESSION_NOT_ALLOW_CANCEL:
      'Không được phép hủy lệnh trong phiên này',
    SYMBOL_NOT_EXIST: 'Không tìm thấy mã phù hợp',
    TRADING_HALT: 'Mã đã ngừng giao dịch',
    CW_TRADING_NOT_ALLOWED__ON_MARGIN_ACCOUNT:
      'Tài khoản margin không được giao dịch chứng quyền',
    EXPIRED_CW: 'Chứng quyền đã đáo hạn',
    VIOLATE_POOL_ROOM: 'Không đủ room',
    PLACE_ORDER_NOT_ALLOW: 'Hệ thống không cho phép đặt lệnh',
    CANCEL_ORDER_NOT_ALLOW: 'Hệ thống không cho phép hủy lệnh',

    PRICE_MUST_LESS_THAN_OR_EQUAL_TO_CEILING_PRICE:
      'Giá nhập phải nhỏ hơn hoặc bằng giá trần',
    PRICE_MUST_GREATER_THAN_OR_EQUAL_TO_FLOOR_PRICE:
      'Giá nhập phải lớn hơn hoặc bằng giá trần',
    INVALID_PRICE_LOT: 'Giá không hợp lệ',
    INVALID_QUANTITY: 'Khối lượng không hợp lệ',
    INVALID_QUANTITY_LOT: 'Khối lượng không hợp lệ',
    INVALID_ORDER_SIDE: 'Lệnh đặt không hợp lệ',
    CAN_NOT_PLACE_ORDER_ON_THIS_SESSION: 'Không thể đặt lệnh ở phiên này',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_ATO_SESSION:
      'Không thể đặt loại lệnh này ở phiên ATO',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_ATC_SESSION:
      'Không thể đặt loại lệnh này ở phiên ATC',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_OPEN_SESSION:
      'Không thể đặt loại lệnh này ở phiên mở cửa',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_RUN_OFF_SESSION:
      'Không thể đặt loại lệnh này ở phiên đóng cửa',
    CAN_NOT_PLACE_ORDER_WITH_THAT_ORDER_TYPE_ON_BEGIN_OF_DAY_SESSION:
      'Không thể đặt loại lệnh này ở phiên đầu ngày',
    CAN_NOT_REPLACE_THAT_ORDER_ON_THIS_SESSION:
      'Không thể thay thế lệnh ở phiên này',
    INVALID_SYMBOL: 'Không có dữ liệu',
    INVALID_PRICE: 'Giá không hợp lệ',
  },
};
